import { attemptChunkLoadRecovery } from "./attempt-chunk-load-recovery";

let isRegistered = false;

// Webpack's runtime rejects CSS chunk loads (code CSS_CHUNK_LOAD_FAILED) outside any
// lazyWithRecovery factory or error boundary, so they only surface as an
// unhandledrejection; route them through the same recovery as JS chunk failures.
export function registerChunkLoadRejectionRecovery(): void {
  if (isRegistered) {
    return;
  }
  isRegistered = true;

  window.addEventListener("unhandledrejection", function recoverChunkLoadRejection(event) {
    if (attemptChunkLoadRecovery(event.reason)) {
      event.preventDefault();
    }
  });
}
